// src/components/Summary.js
import React from 'react';
import { Link } from 'react-router-dom';

const Summary = ({ selectedYear, handleYearChange, annualIncome, annualExpense, annualProfitLoss, selectedMonth, handleMonthChange, monthlyIncome, monthlyExpense, monthlyProfitLoss }) => {
  return (
    <div className="section summary">
      <div className="total">
        <div className="section summary-section">
          <div>
            <select id="yearSelect" value={selectedYear} onChange={handleYearChange}>
              {Array.from({ length: new Date().getFullYear() - 2022 }, (_, i) => 2023 + i).map(year => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            <h2 className="section-title">年收支</h2>
          </div>
          <p>年收入： <span style={{ color: '#3ce200' }}>+{annualIncome.toFixed(2)}</span></p>
          <p>年支出： <span style={{ color: '#ff0000' }}>−{Math.abs(annualExpense).toFixed(2)}</span></p>
          <p>年盈亏： <span style={{ color: annualProfitLoss >= 0 ? '#3ce200' : '#ff0000' }}>
            {annualProfitLoss >= 0 ? '+' : ''}{annualProfitLoss.toFixed(2)}
          </span></p>
        </div>
        <div className="section summary-section">
          <div>
            <select id="monthSelect" value={selectedMonth} onChange={handleMonthChange}>
              {[...Array(12).keys()].map(month => (
                <option key={month + 1} value={month + 1}>{month + 1}月</option>
              ))}
            </select>
            <h2 className="section-title">月收支</h2>
          </div>
          <p>月收入： <span style={{ color: '#3ce200' }}>+{monthlyIncome.toFixed(2)}</span></p>
          <p>月支出： <span style={{ color: '#ff0000' }}>−{Math.abs(monthlyExpense).toFixed(2)}</span></p>
          <p>月盈亏： <span style={{ color: monthlyProfitLoss >= 0 ? '#3ce200' : '#ff0000' }}>
            {monthlyProfitLoss >= 0 ? '+' : ''}{monthlyProfitLoss.toFixed(2)}
          </span></p>
        </div>
      </div>
      <div className='summary-btn-container'>
      <Link to="/expenses">
        <button className='summary-btn'>全部收支</button>
      </Link>
      <Link to="/statistics"> {/* 新增的统计按钮 */}
        <button className='summary-btn'>收支统计</button>
      </Link>
      </div>
    </div>
  );
};

export default Summary;
